// ** React Imports
import { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// ** Redux Imports
import { store } from "./redux/store";
import { Provider } from "react-redux";

// ** Intl, CASL & ThemeColors Context
import ability from "./configs/acl/ability";
import { AbilityContext, AbilityProvider } from "./utility/context/Can";
import { ThemeContext } from "./utility/context/ThemeColors";

// ** ThemeConfig
import themeConfig from "./configs/themeConfig";

// ** Toast
import { ToastPosition, Toaster } from "react-hot-toast";

// ** i18n
import "./configs/i18n";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Hot Toast Styles
import "./@core/scss/react/libs/react-hot-toasts/react-hot-toasts.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";
import "./index.scss";
// ** Service Worker
import * as serviceWorker from "./serviceWorker";

import ReactGA from "react-ga";
import { QueryClientProviderConfig } from "./configs/reactQuery/QueryClientProviderConfig";
import SentryInit from "./configs/sentry/config";
import { AuthProvider } from "./utility/context/AuthContext";
// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

const container: any = document.getElementById("root");
const root = createRoot(container);
const toastPosition = themeConfig.layout.toastPosition as ToastPosition;

import.meta.env.VITE_APP_DEV == "true"
  ? ""
  : ReactGA.initialize("G-BNW2FDRX3C", { debug: false });
SentryInit;
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <QueryClientProviderConfig>
        <Suspense fallback={<Spinner />}>
          <AuthProvider>
            <AbilityProvider>
              <ThemeContext>
                <LazyApp />
                <Toaster
                  position={toastPosition}
                  toastOptions={{ className: "react-hot-toast" }}
                />
              </ThemeContext>
            </AbilityProvider>
          </AuthProvider>
        </Suspense>
      </QueryClientProviderConfig>
    </Provider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
